import { apiCallsPillars } from "../api/calls/pillarControl";

export const exportAutonomusDevices = (markers, filters) => {
  if (markers.length === 0) {
    alert("Δεν υπάρχουν δεδομένα καταγραφής.");
    return;
  }
    const headers = ['DevEUI', 'Latitude', 'Longitude', 'Status Code', 'DeviceUID'];
    const rows = markers.map(marker => {
      const devEUI = marker.deviceName.replace('Συσκευή: ', '').trim();
      const latitude = marker.lat;
      const longitude = marker.lng;
      const statusCode = marker.payload;
      const deviceUID = marker.deviceUid;
     
  
      return [devEUI, latitude, longitude, statusCode, deviceUID].join(',');
    });
  
    const csvContent = '\uFEFF' + [headers.join(','), ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
  
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'devices.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const exportPillarDevices = async (markers, filters) => {
  try {
      const dataForExport = await apiCallsPillars.Actions.GetDevicesForExport(filters);

      if (!dataForExport || dataForExport.length === 0) {
          alert("Δεν υπάρχουν δεδομένα καταγραφής.");
          return;
      }

      const header = [[
          'Ημερομηνία επεξεργασίας',
          'Στιγμή Τελευταίου Μηνύματος',
          'Όνομα Nexiode Device',
          'DEVEUI Controller',
          'Latitude',
          'Longtitude',
          'Ημερομηνία Εγκατάστασης',
          'Σύνολο ημερών',
          'Σύνολο ωρών εργασίας βάση τυπικής ημέρας (11,9)',
          'Συνδεδεμένα Φωτιστικά',
          'Θέσεις Φωτιστικών',
          'Nominal Wattage (Άρθροισμα Εγκατεστημένων Φωτιστικών)',
          'Κατανάλωση Βάση Τυπικής Ημέρας(kWh)',
          'Κατανάλωση Μετρούμενη από Controller',
          'Τάση Τελευταίου μηνύματος (V)',
          'Ώρες εργασίας υπολογισμένες από Μηνύματα',
          'Σύνολο Ωρών από Τελευταίο Μήνυμα',
          'Σύνολο Κατανάλωσης από Τελευταίο Μήνυμα',
          'Wattage Παλαιού συστήματος',
          'Κατανάλωση Παλαιού Συστήματος βάση τυπικής ημέρας (11,9)',
          'New / Old System Wattage Ratio',
          'Σημειώσεις'
      ]];

      const data = dataForExport.map(row => {
          const newRow = [...row];
          newRow.shift();
          return newRow;
      });

      const allRows = header.concat(data);

      const csvRows = allRows.map(row =>
          row.join('|')
              .replace(/Συσκευή:/g, '')
              .replace(/<p>/g, '')
              .replace(/<\/p>/g, '')
              .replace(/<strong>/g, '')
              .replace(/<\/strong>/g, '')
      );

      const csvString = csvRows.join("%0A");

      const a = document.createElement('a');
      a.href = 'data:text/csv;charset=UTF-8,%EF%BB%BF' + csvString;
      a.download = `IoT_${filters.fromDate}_${filters.toDate}.csv`;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

  } catch (error) {
      console.error("Export failed:", error);
  }
};

  